module.exports = __webpack_public_path__ + "static/media/img_snake_end_top.dea7cb81.svg";